import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCwIcon, ActivityIcon, SparklesIcon, ZapIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: <RefreshCwIcon className="w-6 h-6 text-pink-brand" data-id="element-2" />,
    title: 'Regulación del Ciclo',
    description: 'Apoyo a la ovulación natural y regularidad mes a mes.'
  }, {
    icon: <ActivityIcon className="w-6 h-6 text-green-brand" data-id="element-3" />,
    title: 'Control Metabólico',
    description: 'Mejora la respuesta a la insulina, reduciendo antojos y facilitando el manejo de peso.'
  }, {
    icon: <SparklesIcon className="w-6 h-6 text-pink-brand" data-id="element-4" />,
    title: 'Claridad Hormonal',
    description: 'Ayuda a disminuir los niveles de andrógenos (menos acné, menos vello no deseado).'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-green-brand" data-id="element-5" />,
    title: 'Energía Sostenida',
    description: "Sin los 'bajones' de azúcar que causan fatiga crónica."
  }];
  return <section id="beneficios" className="py-20 md:py-32 bg-dark relative" data-id="element-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-8">
          <h2 className="text-3xl md:text-5xl font-heading text-white mb-6" data-id="element-9">
            Un cambio que puedes{' '}
            <span className="text-pink-brand" data-id="element-10">medir y sentir.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-11">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-surface rounded-2xl p-6 border-t-4 border-pink-brand hover:-translate-y-2 transition-transform duration-300" data-id="element-12">
              <div className="mb-6 bg-dark-card w-12 h-12 rounded-full flex items-center justify-center" data-id="element-13">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-14">
                {benefit.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-15">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}